import config from 'config';
import en from './en';
import hy from './hy';

export default {
    [config.localeValues.english]: en,
    [config.localeValues.armenian]: hy,
};



// WEBPACK FOOTER //
// ./src/locales/index.js